interface NavItem {
  title: string;
  key: string;
  path: string;
}

export const navItems: NavItem[] = [
  {
    title: 'Home',
    key: 'home',
    path: '/',
  },
  // {
  //   title: 'News',
  //   key: 'news',
  //   path: '/news',
  // },
  // {
  //   title: 'FAQ',
  //   key: 'faq',
  //   path: '/faq',
  // },
  {
    title: 'Policies',
    key: 'policies',
    path: '/policies',
  },
];
